import { render, staticRenderFns } from "./BrsNihonUView.vue?vue&type=template&id=3c7ed7c2&scoped=true&"
import script from "./BrsNihonUView.vue?vue&type=script&lang=js&"
export * from "./BrsNihonUView.vue?vue&type=script&lang=js&"
import style0 from "./BrsNihonUView.vue?vue&type=style&index=0&id=3c7ed7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ed7c2",
  null
  
)

export default component.exports